let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJagN")).then(() => parcelRequire('2km4Q'));